import HeaderSearchInput from './HeaderSearchInput';

export default HeaderSearchInput;
